// extracted by mini-css-extract-plugin
export var actionButton = "_n5-0";
export var actionMenuContainer = "_n5-i";
export var bubble = "_n5-2";
export var bubbleActionMenu = "_n5-j";
export var bubbleContext = "_n5-6";
export var bubbleItems = "_n5-7";
export var customer = "_n5-3";
export var divider = "_n5-8";
export var fileList = "_n5-9";
export var hiddenComment = "_n5-o";
export var infoAbove = "_n5-a";
export var internal = "_n5-4";
export var lightActionButton = "_n5-1";
export var link = "_n5-b";
export var merchant = "_n5-5";
export var message = "_n5-c";
export var profilePicture = "_n5-e";
export var quillToolbarContainer = "_n5-f";
export var senderDate = "_n5-g";
export var senderDateCustomer = "_n5-h";
export var senderName = "_n5-d";
export var time = "_n5-k";
export var uploadedImage = "_n5-l";
export var username = "_n5-m";
export var xsmall = "_n5-n";